import { getAlbum } from '../builds'

export const getTitleForAlbum = () => (
    getAlbum().title
)
